import React, {Component} from 'react'
import MaterialTable from 'material-table'
import Button from "@material-ui/core/Button";


import { forwardRef } from 'react';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const ReprintButton = (<Button variant="contained" color="primary" >
    Print
</Button>);

const PalletManifestChooser = ({pallets, onSelectPallet, paging=true, search=true, title="Pallet Manifests"}) => {

    if (!pallets)
        pallets = [];

    return (<MaterialTable
            icons={tableIcons}
            title={title}
            columns={[
                {title: 'Id', field: 'id'},
                {title: 'Press', field: 'stationInfo.name'},
                {title: 'Pallet Id', field: 'palletId'},
                {title: 'Loaded', field: 'loadTime', type: 'datetime', filtering: false},
                {title: 'Unloaded', field: 'unloadTime', type: 'datetime', filtering: false},
                {title: 'Jobs Count', field: 'jobCount', type: 'numeric'},
            ]}
            data={pallets}
            actions={[
                {
                    icon: () => ReprintButton,
                    tooltip: 'Print Manifest',
                    onClick: (event, rowData) => onSelectPallet(rowData)
                }
            ]}
            options={{
                filtering: false,
                paging: paging,
                search: search,
                rowStyle: {
                    fontSize: 14,
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    padding: '6px'
                },
                cellStyle: {
                    padding: '6px'
                }
            }}
            // actions={[
            //     {
            //         icon: (<Button variant="contained" color="primary" >
            //             Reprint
            //         </Button>),
            //         tooltip: 'Reprint Pallet Manifest',
            //         onClick: (event, rowData) => onSelectPallet(rowData)
            //     }
            //     ]}
        />
    );
}

export default PalletManifestChooser;